import { ChannelModel } from './channel.model';
import { PaymentGatewayModel } from './payment-gateway.model';
import { isUndefined } from 'util';
import { FillableModel } from './fillable.model';

export class PaymentMethodModel extends FillableModel {
    constructor(
        public id: number = null,
        public type: 'credit card'
            | 'bank slip'
            | 'debit card'
            | 'payment on shipping'
            | 'non-transparent checkout'
            | 'voucher'
            | 'pix' = null,
        public name: string = null,
        public channels: Array<ChannelModel> = [],
        public payment_gateway_tenant: PaymentGatewayModel = null,
        public payment_gateway_tenant_name: string = null,
        public payment_gateway_tenant_id: number = null,
        public discount: number = null,
        public percentual_discount: boolean = null,
        public interest: number = null,
        public percentual_interest: boolean = null,
        public tax_after_due: number = null,
        public percentual_tax_after_due: boolean = null,
        public allow_multiple_cards: boolean = false,
        public allow_3ds: boolean = false,
        public sandbox_3ds: boolean = false,
        public antifraud_option: string = null,
        public suppressed_3ds_challenge: boolean = false,
        public extra_fields: Array<{
            slug: string;
            label: string;
            values: Array<{
                value: string,
                source: string
            }>
        }> = []
    ) {
        super();
    }

    public fill(json: any) {
        if (json.id !== undefined) {
            this.id = json.id;
        }
        if (json.type !== undefined) {
            this.type = json.type;
        }
        if (json.name !== undefined) {
            this.name = json.name;
        }
        if (json.channels !== undefined) {
            this.channels = json.channels;
        }
        if (json.payment_gateway_tenant !== undefined) {
            this.payment_gateway_tenant = new PaymentGatewayModel;
            this.payment_gateway_tenant.name = json.payment_gateway_tenant.name;
            this.payment_gateway_tenant.id = json.payment_gateway_tenant.id;
            this.payment_gateway_tenant_name = json.payment_gateway_tenant.name;
            this.payment_gateway_tenant_id = json.payment_gateway_tenant.id;
        }
        if (json.discount !== undefined) {
            this.discount = json.discount;
        }
        if (json.percentual_discount !== undefined) {
            this.percentual_discount = json.percentual_discount;
        }
        if (json.interest !== undefined) {
            this.interest = json.interest;
        }
        if (json.percentual_interest !== undefined) {
            this.percentual_interest = json.percentual_interest;
        }
        if (json.tax_after_due !== undefined) {
            this.tax_after_due = json.tax_after_due;
        }
        if (json.percentual_tax_after_due !== undefined) {
            this.percentual_tax_after_due = json.percentual_tax_after_due;
        }
        if (json.allow_multiple_cards !== undefined) {
            this.allow_multiple_cards = json.allow_multiple_cards;
        }
        if (json.extra_fields !== undefined) {
            this.extra_fields = json.extra_fields;
        }
        if (json.allow_3ds !== undefined) {
            this.allow_3ds = json.allow_3ds;
        }
        if (json.sandbox_3ds !== undefined) {
            this.sandbox_3ds = json.sandbox_3ds;
        }
        if (json.suppressed_3ds_challenge !== undefined) {
            this.suppressed_3ds_challenge = json.suppressed_3ds_challenge;
        }
        if (json.antifraud_option !== undefined) {
            this.antifraud_option = json.antifraud_option;
        }
    }

    public isCard(): boolean {
        return (this.isCreditCard() || this.isDebitCard() || this.isVoucher());
    }
    public isDebitCard(): boolean {
        return this.type === 'debit card';
    }
    public isCreditCard(): boolean {
        return this.type === 'credit card';
    }
    public isVoucher(): boolean {
        return this.type === 'voucher';
    }
    public usesCardCheckout(): boolean {
        return this.isCreditCard() || this.isVoucher();
    }
    public isBankSlip(): boolean {
        return this.type === 'bank slip';
    }
    public isPaymentOnShipping(): boolean {
        return this.type === 'payment on shipping';
    }
    public isNonTransparentCheckout(): boolean {
        return this.type === 'non-transparent checkout';
    }
    public isPix(): boolean {
        return this.type === 'pix';
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/models/payment-method.model.ts